module.exports = __webpack_public_path__ + "img/malbec-reserva.0ecbaced.jpg";